import { EMPTY, Observable } from 'rxjs';

export class StepModel<T> {
  public label: Observable<string> = EMPTY;
  public stepType: T | undefined;
  public isActive = false;
  public isDisabled = false;
  public show = true;
  public relativeRoute = '';
}
